// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BookingOfferPriceResponse

export type BookingOfferPriceApiResponse = {
	priceId: string;
	unitPrice: number;
	quantity: number;
};

export type BookingOfferPrice = {
	priceId: string;
	unitPrice: number;
	quantity: number;
};

export function hydrateBookingOfferPrice(data: BookingOfferPriceApiResponse): BookingOfferPrice {
	return { ...data };
}